import React, { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  Button,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Grid
} from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { FileUploader } from 'react-drag-drop-files'; // Assuming you're using this package
import AppConfig from "../../AppConfig";
import { useAppData } from "../../redux/appDataProvider";
import ApiClient from "../../utilities/apiClient";
import PdfPreview from './pdfPreview';
import axios from 'axios';
import Swal from 'sweetalert2'
import BSstyles from "../FAndO/ActivateFnO.module.css";
import { useSelector } from 'react-redux';
import MyLodder from "../../components/lodder";
import dayjs from 'dayjs';

const reasons = [
  "Loss in trading",
  "I am not happy with TradeBoss",
  "Financial issues",
  "Not enough time to trade",
  "App has performance issues",
  "I did not receive expected customer support",
  "High/Unclear brokerage charges",
  "I do not have trading knowledge",
  "Others"
];



const checklist = [
  {
    title: "Sold & Withdraw",
    description: "I have sold all my existing holdings and withdrawn funds to my bank account.",
  },
  {
    title: "Downloaded Statements and Reports",
    description: "I have downloaded a copy of Statements and Reports.",
  },
  {
    title: "Understood Permanent Closure",
    description: "I have understood that Account Closure is Permanent and I can re-open the account after 90 days only.",
  },
];

const fileTypes = ['PDF', 'JPG', 'PNG', 'JPEG']; 

export default function AccountClosure() {
  const [step, setStep] = useState(1);
  const [selectedReason, setSelectedReason] = useState('');
  const [isChecklistConfirmed, setIsChecklistConfirmed] = useState(false);
   const [filename2, setFilename2] = useState('');
   const [filenamedata2, setFilenamedata2] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [errtype, setErrtype] = useState(0);
    const [loading, setLoading] = useState(false);
  const [pdfError, setPdfError] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [responseData, setResponseData] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

   const [showlodder, setShowLodder] = useState(false);
   const [callApi,setCallApi]=useState(false)


  const [eSignStatus,setEsignStatus]=useState("")
   const apiToken = useSelector(state => state.auth.apiToken);


  const { userInfo, setUserInfo } = useAppData();
  console.log(userInfo)

  const location = useLocation()

   const [holdingData, setHoldingData] = useState();
   const [holdingsCountt,setHoldingsCount]=useState(0)
   const [openordersCountt,setOpenOrdersCount]=useState(0)

  const userId = useSelector(state => state.auth.userId);
  // const [showmodal, setShowModal] = React.useState(false);

  console.log('holdings from account closure',holdingData)

  const fetchData = async () => {
    try {
      // Replace this with your actual data fetching logic
      // const apiToken ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMzQsImlhdCI6MTcxMTM1MTIxNywiZXhwIjoxNzExMzUzMDE3fQ.W6yAyoTXBefesvAMWN-2MuxVlS1d33l7d_ZGIKUMDcU";
      setShowLodder(true)
      const apiClient = new ApiClient(apiToken);
      apiClient.fetchData(
        AppConfig.api.Client.holdings,
        "POST",
        {
          "CLIENT_ID": userId,
          "TO_DATE": dayjs(new Date()).format('DD/MM/YYYY'),
          "PRICELOGIC": 'S',
        })
        .then((response) => {
          console.info(response);
        
          // if(response===401){setShowModal(true)}
          if(response && response.Success === "False"){
            setShowLodder(false)
            setHoldingData([])
          }
          if(response && response.Success === "True" && response.hasOwnProperty("Success Description")){
            let responseData = response["Success Description"]; 
            console.log(`data ${responseData}`);
            if (Array.isArray(responseData) && responseData.length > 0) {

              let re=responseData.map(data => {
                return {
                  SCRIP_SYMBOL: data.BSE_SHORT_NAME,
  
                  NET:data.NET,
                  PURCHASE_PRICE: data.PURCHASE_PRICE,
                  BUYVAL:(data.NET*data.PURCHASE_PRICE).toFixed(4),
                  SCRIP_VALUE:data.SCRIP_VALUE,
                  AMOUNT:data.AMOUNT,
                  PANDL:(data.AMOUNT-(data.NET*data.PURCHASE_PRICE)).toFixed(4),
                  PERCENT_HOLD:data.PERCENT_HOLD,
                  SCRIP_NAME : data.SCRIP_NAME
                }
  
  
              })
              setShowLodder(false)
              setHoldingData(re);

              const { holdingsCount, openOrdersCount } = re.reduce(
                (acc, item) => {
                  const net = parseFloat(item.NET);
                  if (net === 0) {
                    acc.openOrdersCount++;
                  } else {
                    acc.holdingsCount++;
                  }
                  return acc;
                },
                { holdingsCount: 0, openOrdersCount: 0 }
              );


              console.log("Holdings Count:", holdingsCount);      // 1
              setHoldingsCount(holdingsCount)
              console.log("Open Orders Count:", openOrdersCount); // 1
              setOpenOrdersCount(openOrdersCount)
              
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []); // Empty dependency array to fetch data only once on component mount

  useEffect(() => {
    const baseUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, baseUrl);
    const searchParams = new URLSearchParams(location.search);
    const successParam = searchParams.get("success");

    console.log("success parmas from account closure", typeof successParam)

    if (successParam === 'true') {
      console.log("esign success inside if block and making status as signed -> request raised")
      setEsignStatus('signed')
    }
    if(successParam === 'false'){
      console.log('esign failed showing modal')
       Swal.fire({
              title: "Esign Failed",
              html: `<i class="fas fa-info-circle custom-icon"></i> 
                 <p>Unfortunately, Esign Failed Try again ..!</p>`,
              confirmButtonText: "Ok",
              confirmButtonColor: "#f3d45e",
              background: "#f8f9fa",
              color: "#333",
               customClass: {
                              confirmButton: BSstyles.customConfirmButton,
                            }, 
            });
    }
  }, [location.search]);




  useEffect(() => {
    const fetcheSignStatus = async () => {
      try {
        let payload = {
          clientId: userInfo.CLIENT_ID || localStorage.getItem("userid")
        }

        const apiClient = new ApiClient(apiToken);
        const response = await apiClient.fetchData(
          AppConfig.api.A_closure_status.ac_status,
          "POST",
          payload
        );

        console.log("API Response:", response); // Now this should show the actual data
        console.log("API Response:", response.stage); // Now this should show the actual data

        if (response.stage === 'signed') {
          setEsignStatus('signed')
        }
        else if (response.stage === 'approved') {
          setEsignStatus('approved')
        }
        else if (response.stage === 'rejected') {
          setEsignStatus('rejected')
        }
        else {
          setEsignStatus('not_attempted') // Handle other cases
        }

      } catch (error) {
        console.error('Error fetching eSign status:', error);
      }
    };

    fetcheSignStatus();
  }, []);

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleContinue = async () => {
    const generateRandomDigits = (length) =>
      Math.floor(Math.random() * Math.pow(10, length))
        .toString()
        .padStart(length, '0');


    const randomDigits = generateRandomDigits(4); // 4 random digits
    const payload = {
       data:{
        date: new Date().toLocaleDateString(),
        applicationNumber: `100000${randomDigits}`,
        // accountNumber: "123456789",
        UCCCode: userInfo.CLIENT_ID,
        fullName: userInfo.CLIENT_NAME,
        DpId: userInfo.DP_ID,
        CleintId: userInfo.CLIENT_DP_CODE.substring(8, 16),
        reason: selectedReason,
        Address:userInfo.CL_RESI_ADD1+" "+userInfo.CL_RESI_ADD2+" "+userInfo.CL_RESI_ADD3,
        // PIN: userInfo.PIN_CODE,
        email: userInfo.CLIENT_ID_MAIL,
        mobile:userInfo.MOBILE_NO,
        source: "accountclosure"
      }
    };
    setShowLodder(true);
    setCallApi(true)

    try {
      setPdfError(false);

     const authdata = localStorage.getItem("persist:root");
    const parseData = JSON.parse(authdata);
    const userData = JSON.parse(parseData.auth);
    const apiToken = userData?.apiToken; // Use optional chaining to avoid errors

    console.log(apiToken)

    const apiClient = new ApiClient(apiToken);
    console.log(AppConfig.api.A_closure_preview.ac_preview )
    const response = await apiClient.fetchData(AppConfig.api.A_closure_preview.ac_preview, "POST", payload);
    console.log("ressssw",response)
            setResponseData(payload);

      if (response && response.status === 200) {
        const base64PDF = response.data.data;

        const binaryString = atob(base64PDF);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }

        const blob = new Blob([bytes], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        console.log(url)

        setPdfUrl(url);

        setShowLodder(false);
        setShowPreview(true)
      } else {
        setPdfError(true);
        setShowLodder(false);
      }
    } catch (err) {
      console.error("Error in API:", err);
      setPdfError(true);
      setShowLodder(false);
    }
  };

const handleChangeFile2 = async (file) => {
  setErrtype(0);
  setErrorMsg('');
  const fsize = (file.size / (1024 * 1024)).toFixed(2); // File size in MB

  if (file.type !== 'application/pdf') {
    setErrtype(10);
    setErrorMsg('Invalid File Format (Only PDF files are supported)');
    return;
  }

  if (fsize > 5) {
    setErrtype(10);
    setErrorMsg('Max 5MB allowed');
    return;
  }

  try {
    const base64 = await convertBase64(file);
    setFilenamedata2(base64);
    setFilename2(file.name);
  } catch (e) {
    setErrtype(10);
    setErrorMsg('File processing error');
  }
};


  const navigate=useNavigate()

  const handleNext = () => {
    if (selectedReason) {
      setStep(2);
    } else {
      alert('Please select a reason for closure.');
    }
  };

  // const handleProceed = async() => {
  //   console.log(holdingsData.holdings)
  //   console.log(filenamedata2)
  //   console.log(holdingsData.holdings > 0 && !filenamedata2)

  //    if (holdingsData.holdings > 0 && !filenamedata2) {
  //   setErrtype(10);
  //   setErrorMsg("Please upload CMR Copy as you have holdings.");
  //   return;
  // }

  //    let payload = {
     
  //        "client_code":userInfo.CLIENT_ID,
  //           "emailid": userInfo.CLIENT_ID_MAIL,
  //           "mobileno": userInfo.MOBILE_NO,
  //          "reason_closure":selectedReason,
  //           "afeed":"feedback",
  //           "name":userInfo.CLIENT_NAME,
  //           "data":filenamedata2,
  //           "filenamecmr":`${userInfo.CLIENT_ID}_accountclosure_cmr_copy`
  //       }

  //       console.log(payload)

  //   try{

  //      const apiClient = new ApiClient(apiToken);
  //       const response = await apiClient.fetchData(
  //         AppConfig.api.A_init_closure.ac_init,
  //         "POST",
  //         payload
  //       );
  //      console.log(response)

  //      if(response.message == "Request Initiated"){
  //       console.log("inside RI")
  //        setStep(3);
  //      }

  //   } catch (error){
  //      console.log(error)
  //   }
  // };

  const handleProceed = async () => {
    if (holdingsCountt > 0 && !filenamedata2) {
      setErrtype(10);
      setErrorMsg("Please upload CMR Copy as you have holdings.");
      return;
    }

    setShowLodder(true);
  

    try {
      const formData = new FormData();

      // Create a JSON object with all regular fields
      const jsonPayload = {
        client_code: userInfo.CLIENT_ID,
        emailid: userInfo.CLIENT_ID_MAIL,
        mobileno: userInfo.MOBILE_NO,
        reason_closure: selectedReason,
        afeed: "feedback",
        name: userInfo.CLIENT_NAME,
        filenamecmr: `${userInfo.CLIENT_ID}_accountclosure_cmr_copy`
      };

      // Add the JSON as a string field
      formData.append("data", JSON.stringify(jsonPayload));

      // If there's a file, add it to the FormData
      if (filenamedata2) {
        // Convert base64 to Blob
        const byteCharacters = atob(filenamedata2.split(',')[1]);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        formData.append("document", blob, `${userInfo.CLIENT_ID}_accountclosure_cmr_copy.pdf`);
      }

      const apiClient = new ApiClient(apiToken);
      const response = await apiClient.fetchData(
        AppConfig.api.A_init_closure.ac_init,
        "POST",
        formData
        // Don't set Content-Type header - let the browser set it with the boundary
      );

      if (response.message == "Request Initiated") {
         setShowLodder(false);
   

        setStep(3);
      }

    } catch (error) {
       setShowLodder(false);
   

      console.error("Error in account closure:", error);
      // Handle error
    }
  };

  const handleBack = () => {
    // You can customize this to navigate away or go to previous step
    if (step === 1) {
      navigate('/manageaccounts')
      setErrorMsg("")
    } else {
      setStep(1);
      setErrorMsg("")
    }
  };

  const handleRetake=()=>{
    console.log("inside retake")
    setEsignStatus("")
  }

  if(eSignStatus === 'signed'){
    
    return <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: "140px !important", flexDirection: "column", textAlign: "center" }}>
        <Typography sx={{ fontWeight: "bold", fontSize: { xs: "16px", sm: "22px", md: "30px", lg: "36px" } }}>
       Request raised for Account Closure
        </Typography>

        <Typography sx={{ color: "#f3d45e", fontSize: { xs: "18px", sm: "20px", md: "22px", lg: "24px" }, mt: 2 }}>
          Our team will contact you within 24 hours
        </Typography>
      </Box>
           
  }

    if(eSignStatus === 'approved'){
    
      return <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: "140px !important", flexDirection: "column", textAlign: "center" }}>
        <Typography sx={{ fontWeight: "bold", fontSize: { xs: "16px", sm: "22px", md: "30px", lg: "36px" } }}>
          Your account has been approved for closure
        </Typography>

        <Typography sx={{ color: "#f3d45e", fontSize: { xs: "18px", sm: "20px", md: "22px", lg: "24px" }, mt: 2 }}>
          Please wait while we complete the remaining steps
        </Typography>
      </Box>

           
  }


  if(eSignStatus === 'rejected'){
    
    return <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: "140px !important", flexDirection: "column", textAlign: "center" }}>
        <Typography sx={{ fontWeight: "bold", fontSize: { xs: "16px", sm: "22px", md: "30px", lg: "32px" } }}>
      Unfortunately, your account closure <br></br> request has not been approved.
        </Typography>

       <Button onClick={handleRetake} sx={{ mt: 2 }}>Retake</Button>
      </Box>
           
  }

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', p: 3, position: 'relative' }}>
      {/* Top-right back button */}
    

      {step === 1 && (
        <>
          <Typography
            sx={{
              fontFamily: "Cardium Medium !important",
              fontSize: "20px !important",
              "@media (max-width: 460px)": {
                fontSize: "18px !important",
              },
              "@media (max-height: 660px)": {
                marginTop: "10px !important",
              },
              marginTop: "50px !important",
              color: "#F3D45E",
            }}
          >
            This is rare. Please tell us the issue you are facing
          </Typography>


          <FormControl component="fieldset" sx={{ width: '100%',marginTop:'20px !important' }}>
            <RadioGroup
              value={selectedReason}
              onChange={(e) => setSelectedReason(e.target.value)}
            >
              {reasons.map((reason, index) => (
                <FormControlLabel
                  key={index}
                  value={reason}
                  control={<Radio />}
                  label={reason}
                />
              ))}
            </RadioGroup>
          </FormControl>

                  <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
                      <Button
                          variant="contained"
                          onClick={handleNext}
                          sx={{
                              width: "300px !important",
                              fontFamily: "Cardium Medium !important",
                              height: "40px !important",

                          }}
                      >
                          Proceed to Next
                      </Button>
                  </Box>

        </>
      )}

      {step === 2 && (
        <>
          {/* <div>
          
          <p>
            <span>Current Holdings :</span> {holdingsCountt} &nbsp; | &nbsp; <span>Open orders :</span> {openordersCountt} 
           
          </p>
          </div> */}

          <Typography
            variant="h6"
            gutterBottom
            sx={{
              color: '#F3D45E',
              fontSize: { xs: '16px', sm: '20px' },
              '@media (max-height: 740px)': {
                fontSize: '16px'
              }
            }}
          >
            Please ensure the following before placing an account closure request
          </Typography>

          <List>
            {checklist.map((item, idx) => (
              <ListItem key={idx}>
                <ListItemIcon>
                  <ArrowForwardIosIcon color="primary" fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary={item.title}
                  secondary={item.description}
                  primaryTypographyProps={{
                    fontWeight: 'bold',
                    fontSize: '16px',
                    sx: {
                      '@media (max-height: 740px)': {
                        fontSize: '14px'
                      }
                    }
                  }}
                  secondaryTypographyProps={{
                    fontSize: '14px',
                    sx: {
                      '@media (max-height: 740px)': {
                        fontSize: '12px'
                      }
                    }
                  }}
                />
              </ListItem>
            ))}
          </List>


          <Typography gutterBottom sx={{
            fontSize: {
              xs: '14px', sm: '18px', '@media (max-height: 740px)': {
                fontSize: '16px'
              }
            }
          }}>
            {`Please Upload CMR copy (${holdingsCountt > 0 ? "required" : "optional"})`}
          </Typography>

          <Grid sx={{ width: '100%', mt: 2 }}>
            <FileUploader
              multiple={false}
              maxSize={'1mb'}
              hoverTitle="rAI"
              label="Upload or drop a file right here"
              handleChange={handleChangeFile2}
              name="file"
              types={fileTypes}
            >
              <Grid
                sx={{
                  p: 2,
                  width: '100%',
                  background: '#1B2532',
                  borderRadius: '8px',
                  border: '1px dashed #999999',
                }}
              >
                <Grid
                  sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    // flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: 'center',
                    gap: 1,
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    sx={{
                      color: '#666666',
                      fontFamily: 'Cardium Medium',
                      fontSize: { xs: '10px', sm: '14px' },
                    }}
                  >
                    Drag and Drop here CMR Copy /
                  </Typography>
                  <Typography
                    sx={{
                      cursor: 'pointer',
                      color: '#42A0F7',
                      fontFamily: 'Cardium Medium',
                      fontSize: { xs: '12px', sm: '14px' },
                    }}
                  >
                    Browse File
                  </Typography>
                </Grid>
              </Grid>
            </FileUploader>

            <Grid sx={{ width: '100%', display: 'flex', mt: 1 }}>
              <Grid sx={{ width: '75%' }}>
                <Typography
                  className="upload_tit1"
                  sx={{ mr: '10px', fontSize: { xs: '12px', sm: '14px' } }}
                >
                  {filename2}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          {errorMsg && (
            <Typography
              sx={{
                color: 'red',
                mt: 1,
                fontSize: { xs: '12px', sm: '14px', md: '16px' },
              }}
            >
              {errorMsg}
            </Typography>
          )}

          <FormControlLabel
            control={
              <Checkbox
                checked={isChecklistConfirmed}
                onChange={(e) => setIsChecklistConfirmed(e.target.checked)}
                sx={{ p: { xs: 0.5, sm: 1 } }}
              />
            }
            label="I have completed the above tasks"
            sx={{
              mt: 2,
              '.MuiTypography-root': {
                fontSize: { xs: '12px', sm: '14px' },
              },
               '@media (max-height: 740px)': {
                 mt: 1
              }
            }}
          />


          <Box sx={{ mt: 3, display: 'flex', gap: 2 , '@media (max-height: 740px)': {
                mt: 1
              }}}>
                      <Button
                          variant="outlined"
                          onClick={handleBack}
                          sx={{
                              flex: 1, // Take equal width
                              backgroundColor: 'transparent !important',
                              borderRadius: '4px !important',
                              fontFamily: 'Cardium Medium !important',
                              fontSize: '18px !important',
                              lineHeight: '22px !important',
                              color: '#fff !important',
                              textTransform: 'capitalize !important',
                              padding: '12px 0 !important',
                              border: '1px solid #fff !important',
                          }}
                      >
                          Back
                      </Button>

                      <Button
                          variant="contained"
                          color="primary"
                          onClick={handleProceed}
                          disabled={!isChecklistConfirmed}
                          sx={{
                              flex: 1, // Take equal width
                              borderRadius: '4px',
                              fontFamily: 'Cardium Medium',
                              fontSize: '18px',
                              lineHeight: '22px',
                              textTransform: 'capitalize',
                              padding: '12px 0',
                          }}
                      >
                          Proceed
                      </Button>
                  </Box>
        </>
      )}

      {step === 3 && (
              <Box sx={{ textAlign: 'center',marginTop:"50px !important" }}>
          <Typography
            sx={{
              fontSize: { xs: '20px', sm: '30px' },
              fontWeight: 'bold',
              mb: { xs: 1, sm: 2 },
              fontFamily: 'Cardium Medium',
              color: '#fff',
              textAlign: 'center',
            }}
          >
            ESign For Account Closure Form using Aadhaar
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: '14px', sm: '18px' },
              mb: { xs: 0.5, sm: 1 },
              fontFamily: 'Cardium Light',
              color: '#fff',
              textAlign: 'center',
            }}
          >
            Aadhaar ESign digitally signs account closure form for TradeBoss
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: '14px', sm: '18px' },
              mb: { xs: 2, sm: 4 },
              fontFamily: 'Cardium Light',
              color: '#F3D45E',
              textAlign: 'center',
            }}
          >
            Your Aadhaar must be linked to your mobile number to receive and confirm OTP
          </Typography>


                  {/* 🔍 PDF Preview Component */}
          <PdfPreview
            open={showPreview}
            onClose={() => setShowPreview(false)}
            pdfUrl={pdfUrl}
            loading={loading}
            responseData={responseData}
            callApi={callApi}
          />

                  {/* Buttons */}
          <Box
            sx={{
              mt: 4,
              display: 'flex',
              justifyContent: 'center',
              gap: 2,
              flexDirection: { xs: 'column-reverse', sm: 'row' }, // Column on <600px, Row otherwise
            }}
          >
            <Button
              onClick={() => setStep(2)}
              variant="outlined"
              sx={{
                flex: 1,
                backgroundColor: 'transparent !important',
                borderRadius: '4px !important',
                fontFamily: 'Cardium Medium !important',
                fontSize: '18px !important',
                lineHeight: '22px !important',
                color: '#fff !important',
                textTransform: 'capitalize !important',
                padding: '12px 0 !important',
                border: '1px solid #fff !important',
              }}
            >
              Back
            </Button>

            <Button
              variant="contained"
              color="primary"
              sx={{
                flex: 1,
                borderRadius: '4px',
                fontFamily: 'Cardium Medium',
                fontSize: '18px',
                lineHeight: '22px',
                textTransform: 'capitalize',
                padding: '12px 0',
              }}
              onClick={handleContinue}
            >
              Proceed To Aadhaar ESign
            </Button>
          </Box>

              </Box>
)}
 <MyLodder canShow={showlodder} />
    </Box>
  );
}
